import React from 'react'
import { ThemeConsumer } from 'styled-components'
import Tippy from '@tippyjs/react'
import Button from './Button'
import { trackEvent } from '../utils/analytics'

const TrialDownloadButton = ({
  onClick,
  colorscheme = 'white',
  className,
  location = 'unknown',
  ...props
}) => {
  const handleClick = (e) => {
    trackEvent('download_trial', { location })
    if (onClick) onClick(e)
  }

  return (
    <ThemeConsumer>
      {(theme) => (
        <Tippy
          theme={theme.appearance === 'light' ? 'light' : ''}
          placement={'bottom'}
          content={
            <p>
              💳 No credit card required
              <br />
              💻 Works on macOS 10.14 or newer
            </p>
          }>
          <span style={{ display: 'inline-block' }}>
            <Button
              as="a"
              onClick={handleClick}
              colorscheme={colorscheme}
              className={className}
              {...props}>
              Download free trial
            </Button>
          </span>
        </Tippy>
      )}
    </ThemeConsumer>
  )
}

export default TrialDownloadButton
